import { useEffect, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validateMfaLogin } from "../../api/auth";

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { getUser } from "../../actions/auth";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import BackgroundImage from '../../images/login-background.jpg';

const email = sessionStorage.getItem("email");
const initialState = { error: "", loading: false, success: false };
function reducer(state, action) {
  switch (action.type) {
    case "SUCCESS":
      return { ...initialState, loading: false, success: true };
    case "ERROR":
      return { error: action.payload, loading: false, success: true };
    default:
      return state;
  }
}
const useStyles = makeStyles((theme) => ({
  paperContainer: {
    background: `url(${BackgroundImage})`,
    // backgroundImage: 'linear-gradient(90deg, #1b58af 0%, #2a95f7 100%)',
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0px",
    padding: "0px",
    borderImageSource: "linear-gradient(to right, #92add3, #a1d0fb)",
  },
}));
export default function LoginMfa() {
  const classes = useStyles();
  const [localState, dispatch] = useReducer(reducer, initialState);
  const globalDispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);

  const [mfaOtp, setMfaOtp] = useState("");

  useEffect(() => {
    if (user.token) {
      navigate("/profile", { replace: true });
    }
  }, [user.token]);

  const onFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await validateMfaLogin(email, mfaOtp);
      if (data.status) {
        globalDispatch(getUser(data.token));
        localStorage.setItem("token", data.token);
      } else {
        dispatch({ type: "ERROR", payload: "Wrong OTP" });
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper className={classes.paperContainer}>
      <style>{`
      body {
        margin: 0px;
        padding: 0px;
      }
    `}</style>
      <Container component="main" maxWidth="xs">
        <Box
          style={{
            // backgroundImage: `url(${BackgroundImage})`,
            backgroundSize: "cover",
          }}
        >
          <Box
            component="form"
            display="flex"
            justifyContent="center"
            alignItems="center"
            onSubmit={onFormSubmit}
          >
            <Paper sx={{ p: 1, width: 400 }} elevation={3}>
              <Grid container rowGap={2}>
                <Grid item xs={12} lg={12}>
                  {loading ? <CircularProgress /> : <></>}
                </Grid>
                <Grid item xs={12} lg={12}>
                  {Boolean(localState.error) ? (
                    <Alert severity="error">{localState.error}</Alert>
                  ) : (
                    <Alert severity="success">Enter the OTP sent to {email}</Alert>
                  )}
                </Grid>
                <Grid item xs={12} lg={12}>
                  <TextField
                    size="small"
                    value={mfaOtp}
                    onChange={(e) => setMfaOtp(e.target.value)}
                    variant="outlined"
                    fullWidth
                    required
                    label="OTP"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} lg={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    size="small"
                    fullWidth
                    className="pr-btn"
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Box>
      </Container>
    </Paper>

  );
}
